import "./MOCollective.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntro from "./sections/HeroIntro";
import WhatYoullFind from "./sections/WhatYoullFind";
import WhyJoinBenefits from "./sections/WhyJoinBenefits";
import StayConnectedCta from "./sections/StayConnectedCta";
import ComingSoon from "./sections/ComingSoon";
import Footer from "@/reusable_sections/Footer";
export default function MOCollectivePage() {
  return <div>
      <Header />
      <HeroIntro />
      <WhatYoullFind />
      <WhyJoinBenefits />
      <StayConnectedCta />
      <ComingSoon />
      <Footer />
    </div>;
}